import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 7"
      portada="https://fullcomics18.org/img7/touchuukasou7-1.jpg"
    paginas={[
  "https://fullcomics18.org/img7/touchuukasou7-1.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-2.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-3.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-4.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-5.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-6.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-7.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-8.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-9.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-10.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-11.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-12.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-13.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-14.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-15.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-16.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-17.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-18.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-19.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-20.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-21.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-22.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-23.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-24.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-25.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-26.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-27.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-28.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-29.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-30.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-31.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-32.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-33.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-34.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-35.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-36.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-37.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-38.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-39.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-40.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-41.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-42.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-43.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-44.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-45.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-46.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-47.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-48.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-49.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-50.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-51.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-52.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-53.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-54.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-55.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-56.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-57.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-58.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-59.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-60.jpg",
  "https://fullcomics18.org/img7/touchuukasou7-61.jpg"
]}
      sugeridos={[]}


      info={{
        grupo: "shoot the moon",
    tipo: "	doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Anal", "Beauty Mark", "Big Breasts", "Closed Eyes", "Digital", "FFM Threesome", "Freckles", "Group", "Multi-work Series", "Netorare", "Sex Toys", "Shaved Head", "Shimaidon"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 7",
  portada: "https://fullcomics18.org/img7/touchuukasou7-1.jpg",
  reverso: "https://fullcomics18.org/img7/touchuukasou7-3.jpg",
   fecha:"2026-05-16",


  info: {
    grupo: "shoot the moon",
    tipo: "	doujinshi",
    idioma: "Español",
    serie: "Original",
    personajes: [" "],
etiquetas: ["Anal", "Beauty Mark", "Big Breasts", "Closed Eyes", "Digital", "FFM Threesome", "Freckles", "Group", "Multi-work Series", "Netorare", "Sex Toys", "Shaved Head", "Shimaidon"],
    artistas: "Fuetakishi",
  },
};
